<template>
  <div class="creative-features">
    <div class="wrapper">
      <div
        class="feature-item feature-intro"
        :style="{ backgroundImage: `url(${useCdnUrl()}/assets/creative-services/creative.webp)` }"
      >
        <div class="feature-content">
          <article class="left-top">
            <div></div>
            <div class="feature-title">
              <div class="feature-divider">
                <div class="divider" />
                <div class="dots" />
              </div>
              <h1>Creative</h1>
              <h2>Services</h2>
            </div>
          </article>

          <article class="right-bottom">
            <div class="feature-body">
              <div class="feature-copy">
                Zenapptic’s award-winning Creative Services team has an in-depth understanding of
                data-driven graphics on all the leading real-time platforms and decades of
                experience when it comes to successfully delivering graphics packages across the
                globe for sports, elections, news and more.
              </div>
            </div>
          </article>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
@use "../assets/scss/vars";

.creative-features {
  height: 100vh;
  overflow: hidden;
  position: relative;
  width: 100vw;

  .wrapper {
    height: 100vh;
    position: relative;
    width: 100vw;

    .feature-item {
      align-content: end;
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;
      display: grid;
      height: 100%;
      position: absolute;
      width: 100%;

      &.active {
        left: 0 !important;
        transition: all 1s ease-out;
        z-index: 10;
      }

      .feature-content {
        display: inline-grid;
        grid-template-columns: 1fr 1fr;
        grid-template-rows: auto auto;
        margin: auto auto 4rem auto;
        max-width: 1366px;

        @media only screen and (max-width: 768px) {
          grid-template-columns: 1fr;
          margin-bottom: 0;
        }

        article {
          display: inline-grid;

          &.left-top {
            grid-column-end: 1;
            grid-column-start: 1;
            grid-row-end: 1;
            grid-row-start: 1;
            grid-template-rows: 20px 1fr;
          }

          &.right-bottom {
            grid-column-end: 2;
            grid-column-start: 2;
            grid-row-end: 2;
            grid-row-start: 2;

            @media only screen and (max-width: 768px) {
              grid-column-end: 1;
              grid-column-start: 1;
            }
          }

          .feature-title,
          .feature-body {
            background: rgba(10, 11, 12, 0.85);
          }

          .feature-title {
            padding: 2rem;
            text-align: right;

            @media only screen and (max-width: 768px) {
              padding: 1rem 2rem;
              text-align: left;
            }

            .feature-divider {
              align-items: center;
              display: grid;
              grid-template-columns: auto 30px;

              @media only screen and (max-width: 768px) {
                margin-bottom: 1rem;
              }

              .divider {
                background: rgba(255, 255, 255, 0.25);
                height: 1px;
              }

              .dots {
                background: url(../assets/dots.png) no-repeat center right;
                background-size: 5px 5px;
                content: "";
                height: 5px;
                justify-self: end;
                width: 5px;
              }
            }

            h1,
            h2,
            h3 {
              margin: 0;
              padding: 0;
              text-transform: uppercase;
            }

            h1 {
              color: vars.$primary-color;
              font-size: min(9vw, 6rem);
              font-weight: 500;
              line-height: 1;
            }

            h2 {
              color: #fff;
              font-size: min(9vw, 5rem);
              font-weight: 400;
              line-height: 1;
            }

            h3 {
              color: #fff;
              font-size: min(8vw, 6.5rem);
              font-weight: 500;
              line-height: 1;
            }
          }

          .feature-body {
            color: #fff;
            font-size: min(4.5vw, 2.2rem);
            padding: 2rem;

            @media only screen and (max-width: 768px) {
              padding: 1rem 2rem;
            }

            span {
              color: vars.$primary-color;
            }
          }
        }
      }
    }
  }
}
</style>
